import './App.styling';

import React from 'react';

import CookieConsent from '../../common/CookieConsent';
import ErrorBoundary from '../../common/ErrorBoundary';
import Content from './content/Content';
import Header from './header/Header';

class App extends React.PureComponent {
    render() {
        return (
            <ErrorBoundary>
                <div>
                    <Header/>
                    <Content/>
                    {process.env.BUILD_CONFIG !== 'LOCAL' ?
                            <CookieConsent/> : null}
                </div>
            </ErrorBoundary>
        );
    }
}

export default App;
